import {defineNuxtRouteMiddleware, navigateTo} from "nuxt/app";

import {useAuth} from "../composables/use-auth";

export default defineNuxtRouteMiddleware(async () => {
	const auth = useAuth();

	if (!auth.isAuthenticated()) {
		const url = await auth.login();

		if (url) {
			return await navigateTo(url);
		}
	}
});
